'use client'
import clsx from 'clsx'

import ShareSlider from '@/components/molecules/ShareSlider'

import sectionStyle from '@/components/atoms/Section/Section.module.scss'
import { Heading } from '@/components/atoms/Typography'

import styles from './ShareBox.module.scss'
import { ShareBoxProps } from './ShareBox.types'
import { usePageContext } from '@/contexts/PageContext'
import SharerModel from '@/models/Sharer'

const ShareBox = ({
  title,
  anchor,
}: Omit<ShareBoxProps, 'uuid' | '__type'>) => {
  const { global } = usePageContext()
  const { social_sharer } = global
  const normalizedSharerItems = SharerModel(social_sharer)

  return (
    <section
      id={anchor}
      className={clsx(sectionStyle.section, styles.shareBox)}
    >
      <Heading
        as='h2'
        size='md'
        weight='bold'
        content={title}
      />
      <ShareSlider items={normalizedSharerItems} />
    </section>
  )
}

export default ShareBox
